import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import { Utils } from 'versafleet-core';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppRoutes from './routes';

import '../stylesheets/main.styl';

// this below commented for https://versafleet.atlassian.net/browse/VF-283
/* eslint-disable */
// const storageSettings = { localStorage: { enabled: false } };
// const analytics = window.analytics = window.analytics || []; if (!analytics.initialize) {
//   if (analytics.invoked)window.console && console.error && console.error('Segment snippet included twice.'); else {
//     analytics.invoked = !0; analytics.methods = ['init', 'trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'page', 'once', 'off', 'on']; analytics.factory = function (t) { return function () { const e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics; }; }; for (let t = 0; t < analytics.methods.length; t++) { const e = analytics.methods[t]; analytics[e] = analytics.factory(e); }analytics.load = function (t) { const e = document.createElement('script'); e.type = 'text/javascript'; e.async = !0; e.src = `${document.location.protocol === 'https:' ? 'https://' : 'http://'}cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`; const n = document.getElementsByTagName('script')[0]; n.parentNode.insertBefore(e, n); }; analytics.SNIPPET_VERSION = '3.1.0';
//     analytics.init(null, storageSettings);
//     analytics.load(process.env.SEGMENT_KEY);
//     analytics.page();
//   }
// }

// Set Sentry configuration
if (!__DEV__) {
  Sentry.init({
    dsn: 'https://4dd54cfa9b01420cb6f221142387f6c5@o250887.ingest.us.sentry.io/4351566',
    release: __VERSION__,
    environment: process.env.sentryEnvironment,
    ignoreErrors: ['ChunkLoadError'],
  });
}

Utils.RequestHelper.setBaseUrl(`${process.env.API_URL}/public`);

const Router = __DEV__ ? HashRouter : BrowserRouter;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const container = document.getElementById('main-container');
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />
    <Router>
      <AppRoutes />
    </Router>
  </QueryClientProvider>
);
